
import React from 'react';
import Timeline from '@/components/Timeline';
import SectionHeader from '@/components/SectionHeader';
import SectionTransition from '@/components/ui/SectionTransition';

const HowWeWork = () => {
  return (
    <div className="relative overflow-hidden py-1 md:py-3">
      <div className="container mx-auto px-3 sm:px-4 relative z-10">
        <SectionHeader
          title="How We Transform Your Business"
          subtitle="Our proven development process"
          emoji="🚀"
          titleColor="text-white"
        />
        
        <SectionTransition type="slide-up" delay={0.1} className="mt-2">
          <Timeline />
        </SectionTransition>
      </div>
    </div>
  );
};

export default HowWeWork;
